// extracted by mini-css-extract-plugin
export default {"div":"IndividualProduct_div__gpCuj"};